// extracted by mini-css-extract-plugin
export default {"goods":"Order_goods__8zlWH","total":"Order_total__xXPqI","header":"Order_header__7xO8j"};